import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	ticket: null,
	loadingTicketDetail: false,
	loadingSubmit: false,
	laundry_rooms: [],
	loadingLaundryRooms: false
};

export default function ticketPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_TICKET_DETAIL_PAGE_REQUEST:
		case ActionTypes.GET_TICKET_DETAIL_PAGE_ERROR:
		case ActionTypes.GET_TICKET_DETAIL_PAGE_SUCCESS:
		case ActionTypes.GET_TICKET_DETAIL_LAUNDRY_ROOMS_REQUEST:
		case ActionTypes.GET_TICKET_DETAIL_LAUNDRY_ROOMS_ERROR:
		case ActionTypes.GET_TICKET_DETAIL_LAUNDRY_ROOMS_SUCCESS:
		case ActionTypes.SUBMIT_TICKET_DETAIL_LAUNDRY_ROOM_REQUEST:
		case ActionTypes.SUBMIT_TICKET_DETAIL_LAUNDRY_ROOM_ERROR:
		case ActionTypes.SUBMIT_TICKET_DETAIL_LAUNDRY_ROOM_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_TICKET_DETAIL_PAGE_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_TICKET_DETAIL_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
